import React, { Component } from 'react'
import PerfilConfig from './PerfilUsuario'

import Home from './Home'
import HomeIcon from '@material-ui/icons/Home';
class ComponentName extends Component {
    render() {
        return (
            <div>
                private
            </div>
        )
    }
}


const config = {
    subConfig: [
        {
            route: {
                path: '/',
                exact: true,
                component: Home,
            }

        },
        {
            route: {
                path: '/private/inicio',
                exact: true,
                component: Home,

            }, menu: {
                nome: "Inicio",
                rota: '/private/inicio',
                icone: HomeIcon,
                ordem: 1
            },

        },
        PerfilConfig,

    ],
    route: {
        path: '/private',
        exact: true,
        component: ComponentName,
    },
}


export default config


// WEBPACK FOOTER //
// ./src/routes/private/index.js